// frontend/src/components/route/ProtectedDeliveryRoute.js
// frontend/src/components/route/ProtectedDeliveryRoute.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from '../layouts/Loader';

export default function ProtectedDeliveryRoute({ children }) {
    const deliveryStaffInfo = JSON.parse(localStorage.getItem('deliveryStaffInfo'));
    
    if (!deliveryStaffInfo) {
        return <Navigate to="/delivery/login" />;
    }

    return children;
}